import { noop } from "lodash";

import type { SelectedImage } from "../../store";
import { useImagePostModalStore } from "../../store";

export const useHandleFileSelection = (callback: () => void = noop) => {
  const { addSelectedFiles } = useImagePostModalStore();
  const handleFileSelection = (files: File[]) => {
    const selectedFiles: SelectedImage[] = files.map(file => ({
      file,
      preview: URL.createObjectURL(file),
      crop: { x: 0, y: 0 },
      zoom: 1,
    }));
    addSelectedFiles(selectedFiles);
    callback();
  };

  return {
    handleFileSelection,
  };
};
